import React from "react";
import styles from "./description.module.css";

//import rukovodstvo from "./Rukovodstvo po ekspluatatsii ASUT-601M2.pdf";
import schema from "./schema.png";

class Description extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";
    return (
      <div
        className={styles.container}
        style={{ paddingBottom: firefox ? "4.8%" : "2.4%" }}
      >
        <div className={styles.textWrapper}>
          Интернет-служба (ИС){" "}
          <span className={styles.teploinform}>«Теплоинформ»</span> является
          автоматизированной информационной системой, обеспечивающей сбор данных
          с теплосчетчиков и доступ к ним через сайт{" "}
          <a
            href="http://teplo-inform.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>
          .
        </div>
        <div className={styles.textWrapper}>
          ИС «Теплоинформ» является частным случаем реализации
          измерительно-вычислительной системы (ИВС) АСУТ-601, внесённой в
          Государственный реестр средств измерений с регистрационным номером №.
          20435-04.
        </div>
        <div className={styles.textWrapper}>
          ИС <span className={styles.teploinform}>«Теплоинформ»</span>{" "}
          осуществляет сбор данных со следующих типов теплосчетчиков:
        </div>
        <div className={styles.textWrapper}>
          ВИС.Т, КМ-5, SA-94/1, SA-94/2M, SA-94/3, ТЭМ-104, ТЭМ-106, ТЭМ-05М,
          Магика, ТАРАН-Т, РПТ-1100, РПТ-2200M, Ирвикон, ВКТ-5, ВКТ-7, ЭСКО-Т,
          Взлет-ТСР, Логика СПТ961, ТеРосс-ТМ, СТД, Ирвикон, УВП-280.
        </div>
        <div className={styles.textWrapper}>
          Возможно также подключение следующих теплосчётчиков, счётчиков газа,
          счётчиков воды и электросчётчиков, сертифицированных в составе ИВС
          АСУТ-601:
        </div>
        <div className={styles.textWrapper}>
          Счетчики СТД, Теплосчётчики - регистраторы ТСР-01, Теплосчетчики
          ТСК-7, Счётчики тепла многофункциональные МАКLО, Расходомеры-счетчики
          ультразвуковые УРСВ-010М «ВЗЛЕТ РС», Расходомеры-счетчики
          ультразвуковые многоканальные УСРВ «ВЗЛЕТ МР», Расходомеры-счётчики
          электромагнитные - «ВЗЛЕТ ЭР», Счётчики-расходомеры РМ-5, Корректоры
          СПГ-761, СПГ 762, СПГ 763, Комплексы многониточные измерительные
          микропроцессорные «Суперфлоу-IIET», Корректоры объёма газа SEVC-D,
          Cчетчики электрической энергии трехфазные ПСЧ-3АР.05, Счётчики
          ватт-часов активной энергии переменного тока статические ПСЧ-4ТАК,
          Счётчики электрической энергии трехфазные ПСЧ-4РП.05.2
        </div>
        <div className={styles.textWrapper}>
          Для подключения счётчика к интернет-службе «Теплоинформ» необходимо
          его оснастить «Устройством удаленного доступа», обеспечивающим доступ
          к данным одним из следующих способов:
        </div>
        <ul className={styles.ulWrapper}>
          <li>по сотовым GSM-сетям;</li>
          <li>по проводным телефонным сетям МГТС;</li>
          <li>через интернет;</li>
          <li>по локальной компьютерной сети.</li>
        </ul>
        <br />
        <div
          style={{ fontWeight: "600", textAlign: "center", fontSize: "1.5vw" }}
        >
          Основные функциональные возможности интернет-службы{" "}
          <span className={styles.teploinform}>«Теплоинформ»</span>
        </div>
        <div className={styles.textWrapper}>
          ИС <span className={styles.teploinform}>«Теплоинформ»</span>{" "}
          обеспечивает:
        </div>
        <div className={styles.textWrapper}>
          <span>1)</span>{" "}
          <span style={{ paddingLeft: "1vw" }}>
            Автоматический сбор данных по настраиваемым расписаниям:
          </span>
        </div>
        <ul className={styles.ulWrapper}>
          <li>в определенные дни месяца;</li>
          <li>в ежедневно;</li>
          <li>в определенные часы суток;</li>
          <li>периодически;</li>
          <li>по требованию оператора.</li>
        </ul>
        <div className={styles.textWrapper}>
          <span>2)</span>{" "}
          <span style={{ paddingLeft: "1vw" }}>
            На сайте можно получить следующие типы ведомостей в формате Excel:
          </span>
        </div>
        <ul className={styles.ulWrapper}>
          <li>по абоненту – посуточная;</li>
          <li>по абоненту – почасовая;</li>
          <li>по группе абонентов – итоговая за месяц.</li>
        </ul>

        <div className={styles.textWrapper}>
          <span>3)</span>{" "}
          <span style={{ paddingLeft: "1vw" }}>
            Доступ к ведомостям теплопотребления могут иметь:
          </span>
        </div>
        <ul className={styles.ulWrapper}>
          <li>абоненты;</li>
          <li>организации, обслуживающие узлы учёта тепла;</li>
          <li>управляющие компании;</li>
          <li>теплоснабжающие организации.</li>
        </ul>
        <div className={styles.textWrapper}>
          Доступ к данным сайта{" "}
          <a
            href="http://teplo-inform.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>{" "}
          осуществляется через личный кабинет, вход в который открывается по
          персональному паролю. Для защиты от несанкционированного доступа в
          кабинеты с группой теплосчётчиков используются другие методы защиты.
        </div>
        <div className={styles.textWrapper}>
          На основании данных, прочитанных из теплосчетчика, система формирует
          отчетные ведомости в формате Excel и графики. Пользователь получает
          ведомости и графики на сайте{" "}
          <a
            href="http://teplo-inform.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>{" "}
          с помощью удобного интерфейса или по электронной почте.
        </div>
        <div className={styles.textWrapper}>
          ИС <span className={styles.teploinform}>«Теплоинформ»</span> позволяет
          также читать из теплосчетчика текущие значения параметров
          теплоносителя и состояние теплосистемы в реальном времени:
        </div>
        <ul className={styles.ulWrapper}>
          <li>по запросу через сайт;</li>
          <li>по запросу с мобильного телефона по SMS.</li>
        </ul>
        <div style={{ paddingLeft: "3vw" }}>
          <div className={styles.textWrapper}>
            К «Устройствам удаленного доступа», использующим модем GPRS, можно
            подключить до 8 аналоговых или дискретных датчиков, например:
          </div>
          <ul className={styles.ulWrapper}>
            <li>датчик наличия электропитания;</li>
            <li>датчик проникновения;</li>
            <li>датчик задымления;</li>
            <li>датчик затопления;</li>
            <li>датчик температуры наружного воздуха;</li>
            <li>датчики давления теплоносителя.</li>
          </ul>
          <div className={styles.textWrapper}>
            ИС <span className={styles.teploinform}>«Теплоинформ»</span> может
            осуществлять контроль работы узла учета тепла и сигнализацию
            нарушений по следующим параметрам:
          </div>
          <ul className={styles.ulWrapper}>
            <li>температура в подающем и обратном трубопроводе;</li>
            <li>нарушение температурного графика;</li>
            <li>утечка;</li>
            <li>
              неисправность датчика – выход значения за предельный диапазон;
            </li>
            <li>любые другие параметры.</li>
          </ul>
          <div className={styles.textWrapper}>
            При срабатывании дискретного датчика или возникновении нештатной
            ситуации на узле учета тепла, пользователь информируется следующим
            образом:
          </div>
          <ul className={styles.ulWrapper}>
            <li>SMS-сообщением на мобильный телефон;</li>
            <li>мгновенным сообщением через интернет;</li>
            <li>по электронной почте.</li>
            <li>
              неисправность датчика – выход значения за предельный диапазон;
            </li>
            <li>любые другие параметры.</li>
          </ul>
        </div>
        <div className={styles.textWrapper}>
          Текущее состояние датчиков и архив событий можно посмотреть на сайте.
        </div>
        <div className={styles.textWrapper}>
          ИС <span className={styles.teploinform}>«Теплоинформ»</span>{" "}
          расширяема и может производить сбор данных также с электросчетчиков,
          газосчетчиков и контроллеров.
        </div>
        <br />
        <div style={{ textAlign: "center", fontSize: "1.5vw" }}>
          Структура интернет-службы
        </div>
        <div style={{ textAlign: "center" }}>
          <img src={schema} style={{ width: "53.8em", height: "auto" }} alt ="Схема"/>
        </div>
        <br />
        <div className={styles.textWrapper}>
          Для сбора данных у абонента устанавливается оборудование удаленного
          доступа к теплосчётчику, которое включает в себя модем или GSM-модем.
          Сбор данных происходит в ночное время. Данные хранятся на сервере ИС{" "}
          <span style={{ fontStyle: "italic", fontWeight: "600" }}>
            «Теплоинформ»
          </span>
          .
        </div>
        <br />
        <div
          style={{ fontWeight: "600", textAlign: "center", fontSize: "1.5vw" }}
        >
          Описание работы с интернет-службой{" "}
          <span style={{ fontStyle: "italic", fontWeight: "600" }}>
            «Теплоинформ»
          </span>
        </div>
        <div className={styles.textWrapper}>
          Доступ к ИС{" "}
          <span style={{ fontStyle: "italic", fontWeight: "600" }}>
            «Теплоинформ»
          </span>{" "}
          осуществляется через интернет. Для получения доступа к личному
          кабинету необходимо обратиться в службу технической поддержки, затем
          зайти на сайт{" "}
          <a
            href="http://teplo-inform.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>{" "}
          в личный кабинет и ввести имя и пароль.
        </div>
        <div className={styles.textWrapper}>
          После этого пользователь попадает в личный кабинет, в котором может
          заказать посуточную или почасовую ведомость теплопотребления.
        </div>
      </div>
    );
  }
}

export default Description;
